import ProgressBarLocation from './ProgressBarLocation';

export default ProgressBarLocation;
